import { eventAnalytics } from './eventAnalytics'
import {
  MonetateExperience,
  RecordImpressionOptions,
  RecordNameOptions,
  RecordParamsOptions,
} from './index.d'
import { remoteLog } from './remoteLogger'
import { MONETATE_URL } from './utils'
import { writeCampaigns } from './writeCampaigns'

const getMatchingExperiences = (
  experiences: Array<MonetateExperience>,
  options: RecordImpressionOptions,
): Array<MonetateExperience> => {
  return experiences
    .filter(experience => experience.impressionId)
    .filter(experience => {
      const paramOptions = options as RecordParamsOptions
      if (paramOptions.paramKey && paramOptions.paramValue) {
        return (
          experience.parameters &&
          experience.parameters[paramOptions.paramKey] ===
            paramOptions.paramValue
        )
      }
      return experience.experienceName.includes(
        (options as RecordNameOptions).experienceName,
      )
    })
}

const getImpressionIds = (experiences: Array<MonetateExperience>): string[] => {
  return experiences.map(({ impressionId }) => impressionId) as string[]
}

const recordImpression = async (
  channel: string,
  experiences: Array<MonetateExperience>,
  options: RecordImpressionOptions,
  monetateId: string,
) => {
  if (!channel) {
    throw new Error(`recordImpression: channel is required`)
  }
  if (!monetateId) {
    console.log(`MonetateId is missing`)
    return
  }
  const impressionExperiences = getMatchingExperiences(experiences, options)
  const impressions = getImpressionIds(impressionExperiences)

  if (impressions.length === 0) {
    console.log(`No Impressions found for ${JSON.stringify(options)}`)
    return
  }

  try {
    const response = await fetch(MONETATE_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        channel,
        monetateId,
        events: [
          {
            eventType: 'monetate:record:Impressions',
            impressionIds: impressions,
            includeReporting: true,
          },
        ],
      }),
    })

    writeCampaigns(impressionExperiences)
    eventAnalytics(impressionExperiences)

    console.log(
      `Successfully recorded the impression for ${JSON.stringify(options)}`,
    )
  } catch (error) {
    const logData = {
      impressions,
      monetateId,
      message: (error as Error).message,
    }
    remoteLog(
      new Error(`Failed to record impression: ${(error as Error).message}`),
      logData,
    )
    console.error('Error recording impression:', error)
  }
}

export const recordImpressionByName = (
  channel: string,
  experiences: Array<MonetateExperience>,
  experienceName: string,
  monetateId: string,
) => recordImpression(channel, experiences, { experienceName }, monetateId)

export const recordImpressionByParam = (
  channel: string,
  experiences: Array<MonetateExperience>,
  paramKey: string,
  paramValue: string,
  monetateId: string,
) =>
  recordImpression(channel, experiences, { paramKey, paramValue }, monetateId)
